import { LitElement, html, css } from 'lit';

class DeletePopup extends LitElement {
  static properties = {
     bgColor: {type: String},
     borderRadius: {type: String},
     height: {type: String},
     width: {type: String},
     title: {type: String},
     message: {type: String},
     primaryButtonBgColor: {type: String},
     primaryButtonTextColor: {type: String},
     primaryButtonText: {type: String},
     secondaryButtonText: {type: String},
     secondaryButtonBgColor : {type: String},
     secondaryButtonTextColor: {type: String},
     handleConfirmRemove: {type: Function},
     closeConfirmationPopup: {type: Function},
  };

  static styles = css`
    .confirmation-popup {
      position: fixed;
      border-radius: 8px;
      padding: 12px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .confirmation-popup  svg {
      align-self: center;
    }

    .confirmation-popup-title {
      width: 75%;
      display: block;
      font-size: 22px;
      color: var(--text-primary-color);
      text-align: center;
    }
    .confirmation-popup-message {
      width: 75%;
      display: block;
      font-size: 16px;
      color: #a5a4a7;
      text-align: center;
    }
    .confirmation-buttons {
      display: flex;
      gap: 8px;
      margin-top: 30px;
      width: 100%;
    }

    .confirm-btn {
      padding: 6px 26px;
      border-radius: 4px;
      cursor: pointer;
      border: none;
      width: 50%;
      font-size: 18px;
      height: 50px;
    }


    .background-overlay {
      background: var(--popup-overlay);
      width: 100vw;
      height: 100vh;
      position: fixed;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      left: 0;
      z-index: 100;
    }
    @media (max-width: 768px) {
      .confirmation-popup {
        width: 90%;
      }
    }
  `;

  render() {
    return html`
      <div class="background-overlay">
        <div class="confirmation-popup" style="background-color: ${this.bgColor}; height: ${this.height}; width: ${this.width}">
        <svg width="40px" height="40px" viewBox="-6.96 -6.96 37.92 37.92" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="" transform="matrix(-1, 0, 0, 1, 0, 0)rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(0,0), scale(1)"><rect x="-6.96" y="-6.96" width="37.92" height="37.92" rx="18.96" fill="#ffc2ca" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.24000000000000005"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="10" stroke="#d15e6d" stroke-width="1.7280000000000002"></circle> <path d="M12 17V11" stroke="#d15e6d" stroke-width="1.7280000000000002" stroke-linecap="round"></path> <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#d15e6d"></circle> </g></svg>
         <span class="confirmation-popup-title">${this.title}</span> 
        <span class="confirmation-popup-message">${this.message}</span>
        
          <div class="confirmation-buttons">
            <button class="confirm-btn yes-btn" @click="${this.handleConfirmRemove}" style="background-color: ${this.primaryButtonBgColor}; color: ${this.primaryButtonTextColor}">
             ${this.primaryButtonText}
            </button>
            <button class="confirm-btn no-btn" @click="${this.closeConfirmationPopup}" style="background-color: ${this.secondaryButtonBgColor}; color: ${this.secondaryButtonTextColor}">
            ${this.secondaryButtonText}
            </button>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('delete-popup', DeletePopup);
